export default { sha: 'c18f910505d998665ed2fe1c902eed0610bc1631', buildNumber: 'undefined' }
